// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".welcome-bonus-top-banner a[data-v-5a9e2142]{background-color:#73c8e1;color:#fff;display:block;font-weight:600;padding:1rem 0;text-align:center;-webkit-text-decoration:none;text-decoration:none;width:100%}.welcome-bonus-top-banner .timer[data-v-5a9e2142]{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
